"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeGraph = exports.applyGraph = void 0;

var applyGraph = function applyGraph(entry, graph) {
  if (entry._graph) {
    var index = graph.findIndex(function (_ref) {
      var type = _ref.type;
      return type === '@else/list+object';
    });

    if (index !== -1) {
      graph.splice.apply(graph, [index + 1, 0].concat(_toConsumableArray(entry._graph.slice(0, -1))));
    }
  }

  entry._graph = graph;
  return entry;
};

exports.applyGraph = applyGraph;

var removeGraph = function removeGraph(entry) {
  delete entry._graph;
  return entry;
};

exports.removeGraph = removeGraph;